// ADR 23.9.26w §7 — one stored op, as the request it stands for.
//
// The same `api/flashcards.ts` calls the pages make, so a replay is
// byte-for-byte the request the learner's tap would have sent — including the
// review's `Idempotency-Key`, which is the `opId` minted before its first
// attempt. No abort signal, here or on a direct send (§5).

import { pinCard, pinList, reviewCard, snoozeCard } from '../../api/flashcards'
import type { QueuedOp } from './types'

export async function sendOp(op: QueuedOp): Promise<void> {
  switch (op.kind) {
    case 'review':
      await reviewCard(op.cardId, op.quality, op.opId)
      return
    case 'card_pin':
      return pinCard(op.cardId, op.pinned)
    case 'list_pin':
      return pinList(op.listId, op.pinned)
    case 'snooze':
      await snoozeCard(op.cardId, op.body)
      return
  }
}
